(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-ryf-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      const slides = [...gallery.querySelectorAll('[data-ryf-slide]')];
      if (!slides.length) return;
      gallery.dataset.ready = 'true';
      const thumbs = [...gallery.querySelectorAll('[data-ryf-thumb]')];
      const status = gallery.querySelector('[data-ryf-status]');
      const dialog = gallery.querySelector('dialog');
      let current = 0;
      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
        status.textContent = status.dataset.pattern.replace('__CURRENT__', String(current + 1)).replace('__TOTAL__', String(slides.length));
      }
      show(0);
      gallery.querySelectorAll('[data-ryf-controls], [data-ryf-thumbnails], [data-ryf-prev], [data-ryf-next]').forEach(el => { el.hidden = false; });
      gallery.querySelector('[data-ryf-prev]')?.addEventListener('click', () => show(current - 1));
      gallery.querySelector('[data-ryf-next]')?.addEventListener('click', () => show(current + 1));
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      gallery.addEventListener('keydown', event => {
        if (dialog.open || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      const stage = gallery.querySelector('.ryf-gallery-stage');
      let start = null;
      stage.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) { start = null; return; }
        start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      stage.addEventListener('touchcancel', () => { start = null; }, { passive: true });
      stage.addEventListener('touchend', event => {
        if (!start) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
        start = null;
      }, { passive: true });
      const enlarge = gallery.querySelector('[data-ryf-enlarge]');
      if (typeof dialog.showModal !== 'function') { enlarge.hidden = true; return; }
      enlarge.addEventListener('click', () => {
        const source = slides[current].querySelector('img');
        const image = dialog.querySelector('img');
        image.srcset = source.srcset;
        image.src = source.src;
        image.alt = source.alt;
        dialog.showModal();
      });
      gallery.querySelector('[data-ryf-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
